function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sanitizeColor } from '@guryou/utils';
import { Input } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Block, FlexRow, LittleCircle } from '../content';
const SelectOption = _ref => {
  let {
    name,
    value,
    label,
    circle,
    onChange,
    options,
    disabled,
    removeDuplicate = false,
    none = true,
    noneValue,
    throwError = null,
    errorMessage = null,
    margin = 'normal',
    xs,
    md,
    lg,
    fullWidth = false,
    defaultOptions,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const inputRef = useRef();
  const [localValue, setLocalValue] = useState(value || '');
  const triggerChangeForHiddenField = value => {
    const element = inputRef.current.getElementsByClassName('MuiSelect-nativeInput')[0];
    if (!element) {
      return;
    }
    const lastValue = element.value;
    element.value = value;
    const tracker = element._valueTracker;
    if (tracker) {
      tracker.setValue(lastValue);
    }
    const event = new Event('input', {
      target: element,
      bubbles: true
    });
    element.dispatchEvent(event);
  };
  const handleChange = event => {
    if (!localValue && !event.target.value || localValue === event.target.value) {
      return;
    }
    onChange && onChange(event.target.value, event.target);
    setLocalValue(event.target.value);
    triggerChangeForHiddenField(event.target.value);
  };
  if (!Array.isArray(options)) {
    return null;
  }
  const inputField = /*#__PURE__*/React.createElement(Input, {
    name: name,
    disabled: disabled
  });
  let renderOptions = [...options].map(x => ({
    value: x.value || x.id,
    label: x.label || x.name || x.title,
    color: x.color
  }));
  if (removeDuplicate) {
    renderOptions = [...new Set(renderOptions.map(opt => opt.label))].map(x => ({
      label: x,
      value: options.find(y => y.label === x).value
    }));
  }
  if (defaultOptions) {
    renderOptions = [{
      label: t('GENERAL.showAll'),
      value: 'all'
    }, {
      label: t('GENERAL.withoutGroup'),
      value: 'noGroup'
    }, ...renderOptions];
  }
  const marginStyleProps = !xs && !md ? {
    margin
  } : {};
  const content = /*#__PURE__*/React.createElement(FormControl, _extends({
    error: !!throwError
  }, marginStyleProps, {
    fullWidth: fullWidth
  }), label && /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(Select, _extends({
    value: localValue
  }, rest, {
    onChange: handleChange,
    input: inputField,
    ref: inputRef
  }), none && /*#__PURE__*/React.createElement(MenuItem, {
    key: "none",
    value: ""
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontStyle: 'italic'
    }
  }, noneValue || 'None')), renderOptions.map((x, i) => /*#__PURE__*/React.createElement(MenuItem, {
    key: i,
    value: x.value
  }, /*#__PURE__*/React.createElement(FlexRow, {
    alignItems: "center",
    margin: 0
  }, circle && x.color && /*#__PURE__*/React.createElement(LittleCircle, {
    backgroundColor: sanitizeColor(x.color),
    marginRight: 2
  }), x.label)))), throwError && errorMessage && /*#__PURE__*/React.createElement(FormHelperText, null, errorMessage));
  if (xs || md || lg) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md,
      lg: lg
    }, marginProps), content);
  }
  return content;
};
export default SelectOption;